export const PLATFORM_NAME = "Polenica";
export const PLATFORM_CITY_LABEL = "de Medellin";
export const PLATFORM_SCOPE_LABEL = "Medellin y el Valle de Aburra";

export const PLATFORM_FOOTER_TEXT =
  'Polenica: sistema de huertas y pacas urbanas de Medellin. Plataforma desarrollada en el marco del proyecto "Medellin resiliente ante el cambio climatico, colegios medioambientalmente sostenibles". Asamblea de Cooperacion por la Paz (ACPP) y Fundacion Forjando Futuros (FFF). Financia: Ayuntamiento de Madrid.';

export const PLATFORM_LINKS = {
  directoryConditions:
    "https://fundacioforjandofuturos-my.sharepoint.com/personal/proyectos_internacionales_forjandofuturos_org/Documents/Polenica/Informacion%20general%20y%20condiciones%20del%20directorio.docx",
  forumConditions:
    "https://fundacioforjandofuturos-my.sharepoint.com/personal/proyectos_internacionales_forjandofuturos_org/Documents/Polenica/Informacion%20general%20y%20condiciones%20del%20foro.docx",
  libraryConditions: "/docs/condiciones-biblioteca-comunitaria.html",
};

export const AREA_METROPOLITANA_MUNICIPALITIES = [
  { value: "Barbosa", label: "Barbosa" },
  { value: "Bello", label: "Bello" },
  { value: "Caldas", label: "Caldas" },
  { value: "Copacabana", label: "Copacabana" },
  { value: "Envigado", label: "Envigado" },
  { value: "Girardota", label: "Girardota" },
  { value: "Itagui", label: "Itagui" },
  { value: "La Estrella", label: "La Estrella" },
  { value: "Medellin", label: "Medellin" },
  { value: "Sabaneta", label: "Sabaneta" },
];

export const POPULATION_FOCUS_OPTIONS = [
  "Mujeres",
  "Poblacion LGBTIQ+",
  "Victimas del conflicto armado",
  "Ninas, ninos y adolescentes",
  "Jovenes",
  "Personas mayores",
  "Personas con discapacidad",
  "Comunidades campesinas",
  "Comunidades afrodescendientes",
  "Comunidades indigenas",
  "Poblacion migrante",
  "Poblacion firmante de paz o en reincorporacion",
  "Comunidad en general",
  "Otro",
  "Prefiero no responder",
];

export const DIRECTORY_TYPE_OPTIONS = [
  {
    value: "PRODUCTO_AGROECOLOGICO",
    label: "Productos agroecologicos",
    publicationType: "producto",
    category: "alimentos",
  },
  {
    value: "ALIMENTO_TRANSFORMADO",
    label: "Alimentos transformados",
    publicationType: "producto",
    category: "alimentos",
  },
  {
    value: "INSUMO",
    label: "Insumos",
    publicationType: "producto",
    category: "insumos",
  },
  {
    value: "SERVICIO_TECNICO_FORMATIVO",
    label: "Servicios tecnicos o formativos",
    publicationType: "servicio",
    category: "formacion",
  },
  {
    value: "ARTE_CULTURA_EDUCACION",
    label: "Arte, cultura y educacion ambiental",
    publicationType: "servicio",
    category: "comunidad",
  },
  {
    value: "OTRO",
    label: "Otros productos o servicios",
    publicationType: "servicio",
    category: "comunidad",
  },
];

export const DIRECTORY_FOCUS_OPTIONS = [
  "Liderazgo de mujeres",
  "Economia solidaria",
  "Soberania alimentaria",
  "Saberes populares o ancestrales",
  "Justicia ambiental",
  "Inclusion y diversidad",
  "Ninez y juventud",
  "Derechos humanos",
];

export const AGENDA_TYPE_OPTIONS = [
  { value: "encuentro", label: "Formacion y dialogo" },
  { value: "actividad", label: "Trabajo comunitario y siembra" },
  { value: "foro", label: "Ferias e intercambios" },
  { value: "reunion", label: "Recorridos y experiencias territoriales" },
  { value: "taller", label: "Cultura, cocina y encuentro comunitario" },
  { value: "capacitacion", label: "Otros" },
];

export const AGENDA_CATEGORY_OPTIONS = [
  "Genero / participacion de mujeres",
  "Derechos humanos",
  "Diversidad",
  "Juventud / ninez",
  "Medio ambiente y justicia climatica",
  "Comunidad / participacion ciudadana",
];

export const AGENDA_COST_OPTIONS = [
  "Gratuito",
  "Pago",
  "Aporte voluntario",
  "Intercambio / trueque",
];

export const INITIATIVE_ACCESS_OPTIONS = [
  { value: "ABIERTO", label: "Abierta al publico" },
  { value: "RESTRINGIDO", label: "Con visita acordada" },
  { value: "PRIVADO", label: "Privada" },
];

export function getDirectoryTypeLabel(value) {
  return DIRECTORY_TYPE_OPTIONS.find((option) => option.value === value)?.label || value || "Otro";
}

export function parseStoredList(value) {
  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    return value.filter(Boolean);
  }

  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) {
        return parsed.filter(Boolean);
      }
    } catch (_error) {
      return value
        .split("|")
        .map((item) => item.trim())
        .filter(Boolean);
    }
  }

  return [];
}

export function serializeList(value) {
  if (!Array.isArray(value)) {
    return "[]";
  }
  return JSON.stringify(value.filter(Boolean));
}
